
export default {
  props: {
    tips: {
      type: Object,
      default: () => {}
    },
    url: {
      type: String,
      default: ''
    },
    urltype: {
      // 跳转类型webUrl--在线开户；sites---官网网址
      type: String,
      default: 'webUrl'
    },
    tipstype: {
      type: String,
      default: ''
    },
    ourl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    console.log('文字版交易商[新版],打开官方网址', this.url)
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      if (this.tipstype == '1') {
        if (this.urltype == 'webUrl') {
          const u = this.url.includes('http') ? this.url : `https://${this.url}`
          window.open(u)
        } else if (this.urltype == 'sites') {
          const u = this.ourl.includes('http') ? this.ourl : `https://${this.ourl}`
          window.open(u)
        }
      } else {
        this.$emit('iframeif', true)
      }
      this.show = false
      this.$emit('close')
    }
  }
}
